import { MaterialUICore, axiomTokens } from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { color, spacing, font, border } = axiomTokens;

export const Link = styled('a')(() => ({
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
  },
  '&:focus': {
    textDecoration: 'none',
  },
  '&:visited': {
    textDecoration: 'none',
  },
  color: color.typeface.pure,
}));

export const ButtonStyled = styled('button')(({ theme }) => ({
  width: '96px',
  height: '80px',
  background:
    'linear-gradient(135deg, #FBDFE9 0%, #eee2fd 20%, #fff 64%, #d6e9ff 100%)',
  borderRadius: border.radius.sm,
  border: `${border.width.xs} solid ${theme.palette.grey[100]}`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: spacing[2],
  color: color.typeface.strong,
  '&:hover': {
    // legacy color
    borderColor: theme.palette.primary.main,
    background:
      'linear-gradient(135deg, #E50052 0%, #732DD2 50%, #046EEC 100%)',
    color: color.inverse.typeface.strong,
    '& #beta-badge': {
      background:
        'linear-gradient(135deg, #FBDFE9 0%, #eee2fd 20%, #ffffffe3 64%, #d6e9ff 100%)',
      color: color.typeface.onInteractive.subtle,
    },
    '& svg': {
      color: color.inverse.icon.hovered,
      transform: 'rotate(180deg)',
    },
  },
  '& #beta-badge': {
    background:
      'linear-gradient(135deg, #B40442 0%, #732dd2 50%, #0857b4 100%)',
    color: color.inverse.typeface.pure,
  },
  '& svg': {
    color: '#455A64',
    transition: 'transform 1s ease',
  },
}));

export const TopContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const TextContainer = styled('div')(({ theme }) => ({
  textAlign: 'left',
  fontSize: 10,
  fontWeight: font.weight.bold,
  fontStyle: 'normal',
  letterSpacing: 0.444444,
  lineHeight: '12px',
  fontFamily: theme.typography.fontFamily,
}));

export const Badge = styled('div')(() => ({
  padding: `${spacing[1]} ${spacing[2]}`,
  borderRadius: border.radius.sm,
  fontSize: font.size.xxxs,
  fontFamily: font.family.base,
  fontWeight: font.weight.medium,
  letterSpacing: font.letterSpacing.md,
  lineHeight: '132%',
}));
